export { PromotionalMessage } from './PromotionalMessage'
